import { render, staticRenderFns } from "./table.vue?vue&type=template&id=6c60c0c4&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c60c0c4')) {
      api.createRecord('6c60c0c4', component.options)
    } else {
      api.reload('6c60c0c4', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=6c60c0c4&", function () {
      api.rerender('6c60c0c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/plugins/export/table.vue"
export default component.exports